import moment from 'moment'

export default class NotificationDomain {
	/**
	 * Handles the default constructor
	 * @param {boolean} breakdown - notify on breakdown
	 * @param {boolean} vehicleRolling - notify when vehicle is rolling
	 * @param {number} id - id
	 * @param {boolean} isCreate - in create mode
	 * @param {boolean} isUpdate - in update mode
	 * @param {boolean} isDelete - in delete mode
	 * @param {boolean} isReadOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {NotificationDomain} - returns the new NotificationDomain object
	 */
	constructor(breakdown, vehicleRolling, id, isReadOnly, createdAt, updatedAt) {
		this.breakdown = breakdown || false
		this.vehicleRolling = vehicleRolling || false 
		this.id = id 
		this.isCreate = false
		this.isUpdate = false
		this.isDelete = false
		this.isReadOnly = isReadOnly
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/domains/NotificationDomain.js